import type { Tenant } from "@/mocks/superadmin/tenants";

interface ImpersonateModalProps {
  tenant: Tenant;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export default function ImpersonateModal({ tenant, onClose, onConfirm, loading }: ImpersonateModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-foreground-950/40" onClick={onClose}></div>

      <div className="relative bg-background-50 rounded-xl border border-background-200 w-full max-w-md">
        <div className="px-6 py-5">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-amber-100 flex items-center justify-center">
            <i className="ri-shield-user-line text-xl text-amber-600"></i>
          </div>

          <h2 className="text-lg font-heading font-bold text-foreground-900 text-center mb-2">
            Login as Tenant
          </h2>
          <p className="text-sm text-foreground-500 text-center leading-relaxed mb-2">
            You are about to impersonate
          </p>
          <div className="bg-background-100 rounded-lg p-3 mb-4 text-center">
            <p className="text-sm font-semibold text-foreground-900">{tenant.businessName}</p>
            <p className="text-xs text-foreground-500">{tenant.ownerName} &middot; {tenant.city}</p>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-5">
            <div className="flex items-start gap-2">
              <i className="ri-alert-line text-amber-600 text-sm mt-0.5"></i>
              <div>
                <p className="text-xs font-semibold text-amber-700 mb-1">Important</p>
                <p className="text-[11px] text-amber-600 leading-relaxed">
                  All actions performed during this session will be logged under your admin account for audit purposes. You will be logged out of the admin panel temporarily.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-100 px-6 py-4 flex items-center justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-foreground-600 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-60"
          >
            <i className={loading ? "ri-loader-4-line animate-spin" : "ri-login-box-line"}></i>
            {loading ? "Opening..." : "Confirm Login As"}
          </button>
        </div>
      </div>
    </div>
  );
}